import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Customer } from '@df/session/api/customer';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { LocalCustomerModel } from '../../../customer/customer.model.decorator';
import { NAntavo } from '../../../module/antavo/antavo.interface';
import { AntavoService } from '../../../module/antavo/antavo.service';
import { NAccountMissions } from './account-missions.component';

/**
 * Resolver to load Antavo challenges for the missions page
 */
export const accountMissionsResolver: ResolveFn<NAntavo.IChallengesResponse | undefined> = async () => {
    const antavoService = inject(AntavoService);
    const customer = inject(Customer);
    const iCmsBlockResource = inject(ICmsBlockResource);

    const customerModel = (await customer.model.load()) as LocalCustomerModel;

    if (!customerModel?.loyaltyId) {
        return undefined;
    }

    await iCmsBlockResource.retrieve({ bareUrl: NAccountMissions.componentId }, undefined);

    try {
        return await antavoService.getChallenges(customerModel.loyaltyId);
    } catch (error) {
        console.error('Failed to load challenges:', error);
        return undefined;
    }
};
